
import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './Footer.css'
import Messenger from './Messenger';

export default class Footer extends Component {
  render() {
    return (
      <footer className="footer">
        <div className="footer-inner">
          <div className="footer-brand">
            <Link className="brand" to="/">
              <img className="brand-logo" src="/images/atlas-sport-liquid.png" alt="" />
              <span>Atlas <strong>Sport</strong></span>
            </Link>
            <p>The simple training log for athletes who want to remember every session and measure real progress.</p>
          </div>
          <div className="footer-column">
            <strong>Legal</strong>
            <Link to="/privacy-policy">Privacy policy</Link>
            <Link to="/terms-and-conditions">Terms &amp; conditions</Link>
            <Link to="/eula">EULA</Link>
            <Link to="/disclaimer">Disclaimer</Link>
          </div>
          <div className="footer-column">
            <strong>Follow Atlas</strong>
            <a href="https://www.instagram.com/atlassport.app/" target="_blank" rel="noreferrer">Instagram</a>
            <a href="https://www.facebook.com/AtlasSportApp" target="_blank" rel="noreferrer">Facebook</a>
            <a href="mailto:contact@atlas-sport.app?subject=Atlas%20Sport%20request">Contact</a>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Atlas Sport. All rights reserved.</span>
          <span>Attempts make success.</span>
        </div>
        <Messenger />
      </footer>
    )
  }
}
